$(document).ready(function () {
  function removeProductFromCartAndSoldOut(productID, selector) {
    var cartItems = localStorage.getItem("cart_items");
    var data = cartItems ? JSON.parse(cartItems) : {};

    var qtySelector = selector.find(".quantity-selector");
    var addToCartBtn = selector.find(".add-to-cart-btn");
    var soldOutBtn = selector.find(".sold-out-btn");

    if (data.hasOwnProperty(productID)) {
      delete data[productID];
    }
    qtySelector.addClass("hide");
    addToCartBtn.addClass("hide");
    soldOutBtn.removeClass("hide");
    if (selector.find("#add-to-routine").length > 0) {
      selector.find("#add-to-routine").addClass("hide");
    }

    localStorage.setItem("cart_items", JSON.stringify(data));
    updateDiscountProgress();
  }

  function toggleQuantityUI() {
    var cartItems = localStorage.getItem("cart_items");
    var data = cartItems ? JSON.parse(cartItems) : {};

    $(".routine-modal-wrapper .atc-btn").each(function () {
      var $parent = $(this);
      var addToCartBtn = $parent.find(".add-to-cart-btn");
      var idInputSelector = $parent.find("input[name='id']");
      var productID = idInputSelector.val();
      var qtySelector = $parent.find(".quantity-selector");
      var qtyInput = $parent.find("input[name='quantity']");
      var avaibility = $parent.find("input[name='avaibility']");
      var isFound = false;
      
      if (avaibility.length > 0 && avaibility.val() != "true") {
        removeProductFromCartAndSoldOut(productID, $parent);
        return;
      }

      if (data.hasOwnProperty(productID) && $(this).closest(".product-bottom-text-last").find(".variant-wrapper").length == 0) {
        qtySelector.removeClass("hide");
        addToCartBtn.addClass("hide");
        qtyInput.val(data[productID].qty);

        if (
          data[productID].image &&
          data[productID].alt &&
          $(
            ".routine-modal-wrapper .lhs-image-wrapper .selected-product-img img[data-id='" +
              productID +
              "']"
          ).length === 0
        ) {
          $(
            ".routine-modal-wrapper .lhs-image-wrapper .selected-product-img"
          ).append(
            '<img src="' +
              data[productID].image +
              '" alt="' +
              data[productID].alt +
              '" data-id="' +
              productID +
              '" />'
          );
        }
        isFound = true;
      } else if (
        $(this).closest(".product-bottom-text-last").find(".variant-wrapper")
          .length > 0
      ) {
        for (var key in data) {
          var $this = $(
            ".routine-modal-wrapper .step-2 .variant-input[data-id='" +
              key +
              "']"
          );
          if ($this.length > 0) {
            qtySelector.removeClass("hide");
            addToCartBtn.addClass("hide");
            qtyInput.val(data[key].qty);
            idInputSelector.val(key);
            idInputSelector.attr("data-prev-id", key);

            var $radio = $(this)
            .closest(".product-bottom-text-last")
            .find("input[data-color-name='" + $this.attr("data-value") + "']");
      
            $(this).closest(".product-bottom-text-last").find("input[type='radio']").removeClass("checked").prop("checked", false);;
            $radio.each(function () {
              if (!$(this).hasClass("checked")) {
                $(this).addClass("checked");
                $(this).prop("checked", true);
              }
            });

            if (
              data[key].image &&
              data[key].alt &&
              $(
                ".routine-modal-wrapper .lhs-image-wrapper .selected-product-img img[data-id='" +
                  key +
                  "']"
              ).length === 0
            ) {
              $(
                ".routine-modal-wrapper .lhs-image-wrapper .selected-product-img"
              ).append(
                '<img src="' +
                  data[key].image +
                  '" alt="' +
                  data[key].alt +
                  '" data-id="' +
                  key +
                  '" />'
              );
            }
            $(
              ".routine-modal-wrapper .step-2 .variant__label .variant__label-info span"
            ).text($this.data("value"));
            $this.trigger("click");
            isFound = true;
          }
        }
      }

      if (!isFound) {
        qtySelector.addClass("hide");
        addToCartBtn.removeClass("hide");
        qtyInput.val(1);
      }
    });

    updateImage(data);
  }

  function updateImage(data) {
    if (Object.keys(data).length === 0) {
      $(
        ".routine-modal-wrapper .lhs-image-wrapper .selected-product-img"
      ).addClass("hide");
      $(".routine-modal-wrapper .lhs-image-wrapper .default-img").removeClass(
        "hide"
      );
    } else {
      $(".routine-modal-wrapper .lhs-image-wrapper .default-img").addClass(
        "hide"
      );
      $(
        ".routine-modal-wrapper .lhs-image-wrapper .selected-product-img"
      ).removeClass("hide");
    }
  }

  function updateLocalStorageQty($input) {
    var $parent = $input.closest(".atc-btn");
    var productID = $parent.find("input[name='id']").val();
    var quantity = parseInt($input.val());
    var cartItems = localStorage.getItem("cart_items");
    var data = cartItems ? JSON.parse(cartItems) : {};

    if (data.hasOwnProperty(productID) && quantity > 0) {
      data[productID].qty = quantity;
    } else if (quantity == 0) {
      delete data[productID];
      $parent.find(".quantity-selector").addClass("hide");
      $parent.find(".add-to-cart-btn").removeClass("hide");
    }
    localStorage.setItem("cart_items", JSON.stringify(data));

    updateImage(data);
    updateDiscountProgress();
  }

  function updateDiscountProgress() {
    var cartItems = localStorage.getItem("cart_items");
    var data = cartItems ? JSON.parse(cartItems) : {};
    var totalQty = 0;
    var isPreOrder = false;

    // Sum total quantity from localStorage
    for (var key in data) {
      if(data[key].isGift == false){
        totalQty += parseInt(data[key].qty);
      }
      if(data[key].isPreOrder == true){
        isPreOrder = true;
      }
    }

    if(isPreOrder){
      $(".delivery-info").addClass("hide");
      $(".delivery-info.pre").removeClass("hide");
    }else{
      $(".delivery-info").removeClass("hide");
      $(".delivery-info.pre").addClass("hide");
    }

    // Select all discount step items
    var $steps = $(".discount-step__item");
    $steps.removeClass("active").removeClass("complete"); // Reset all first

    // Add classes based on quantity
    if (totalQty >= 1) {
      $steps.eq(0).addClass("active");
    }
    if (totalQty >= 2) {
      $steps.eq(0).addClass("complete").removeClass("active");
      $steps.eq(1).addClass("active");
    }
    if (totalQty >= 3) {
      $steps.eq(1).addClass("complete").removeClass("active");
      $steps.eq(2).addClass("active");
    }
    if (totalQty >= 4) {
      $steps.eq(2).addClass("complete").removeClass("active");
      $steps.eq(3).addClass("active");
    }
    if (totalQty >= 5) {
      $steps.eq(3).addClass("complete").removeClass("active");
      $steps.eq(4).addClass("active");
    }

    // Update hint text
    var $hint = $(".discount-step__hint");
    if (totalQty < 2) {
      $hint.text("Add " + (2 - totalQty) + " more items for 5% off");
    } else if (totalQty < 3) {
      $hint.text("Add " + (3 - totalQty) + " more item for 10% off");
    } else if (totalQty < 4) {
      $hint.text("Add " + (4 - totalQty) + " more item for 15% off");
    } else if (totalQty < 5) {
      $hint.text("Add " + (5 - totalQty) + " more item for free gift");
    } else {
      $hint.text("");
    }

    updateTotalAmount();
  }

  function updateTotalAmount() {
    var cartItems = localStorage.getItem("cart_items");
    var data = cartItems ? JSON.parse(cartItems) : {};
    var total = 0;
    var subtotal = 0;
    var totalQty = 0;
    var giftPrice = 0;

    for (var key in data) {
      var item = data[key];
      if(data[key].isGift == false){
        total += item.qty * item.price;
        totalQty += item.qty;
      }else{
        giftPrice += item.qty * item.price;
      }
    }

    $(".gift-product .add-to-cart-btn").removeClass("hide");
    $(".gift-product .free-gift-text").addClass("hide");
    $(".gift-wrapper .locked").removeClass("hide");
    $(".gift-wrapper .unlocked").addClass("hide");
    $(".gift-product .add-to-cart-btn").text($(".gift-product .add-to-cart-btn").attr("data-amount"));
    // Apply discount based on quantity tiers
    var discountRate = 0;
    if (totalQty >= 5) {
      discountRate = 0.15;
      $(".gift-wrapper .locked").addClass("hide");
      $(".gift-wrapper .unlocked").removeClass("hide");
      $(".gift-product .add-to-cart-btn").addClass("hide");
      $(".gift-product .free-gift-text").removeClass("hide");
      // $(".gift-product .add-to-cart-btn").text($(".gift-product .add-to-cart-btn").attr("data-currency-symbol")+"0.00");
    } else if (totalQty >= 4) {
      discountRate = 0.15;
    } else if (totalQty >= 3) {
      discountRate = 0.1;
    } else if (totalQty >= 2) {
      discountRate = 0.05;
    }

    var discountAmount = total * discountRate;
    if(totalQty < 5){
      subtotal = (total + giftPrice) - discountAmount;
    }else{
      subtotal = total  - discountAmount;
    }
    

    // Convert back to £
    $(".discount-step__savings span").text(discountAmount.toFixed(2));
    $(".discount-step__total span.total-qty").text(totalQty);
    if (discountAmount > 0) {
      $(".discount-step__total .total-amount .disable")
        .text(
          $(".discount-step__total .total-amount .disable").data("symbol") +
            "" +
            (total + giftPrice).toFixed(2)
        )
        .show();
      $(".amount").text(subtotal.toFixed(2));
    } else {
      $(".discount-step__total .total-amount .disable").text("").hide();
      $(".amount").text(subtotal.toFixed(2));
    }
  }

  // Initial check on page load
  localStorage.removeItem("cart_items");
  updateDiscountProgress();

  // open routine product modal
  $(document).on("click", "#routineModal", function () {
    
    $(".discount-step__header").removeClass("active");
    $(".routine-modal-steps .step").removeClass("active");
    $(".discount-step__header[data-step='1']").addClass("active");
    $(".routine-modal-steps .step-1").addClass("active");
    $(".next-btn #nextStep").removeClass("hide");
    $(".next-btn #backStep").addClass("hide");
    $(".next-btn #addAll").addClass("hide");
    $(".routine-modal").show();
    $("html").css("overflow", "hidden");
  });

  $(document).on("click", ".routine-modal-close", function () {
    $(".routine-modal").hide();
    $("html").css("overflow", "auto");
  });

  $(document).off("click", ".routine-modal-wrapper .variant-input").on("click", ".routine-modal-wrapper .variant-input", function () {
    var $this = $(this);
    // if ($this.data('clicked')) return; // prevent double-click bug
    // $this.data('clicked', true);
    // setTimeout(() => $this.removeData('clicked'), 100); // reset click guard
    
    var actBtn = $(this).closest(".product-bottom-text-last").find(".atc-btn");
    var title = $(this).data("value");
    var variantId = $(this).data("id");
    var amount = $(this).data("amount");
    var prevProdId = actBtn.find(" input[name='id']").val();

    var cartItems = localStorage.getItem("cart_items");
    var data = cartItems ? JSON.parse(cartItems) : {};

    $(
      ".routine-modal-wrapper .step-2 .variant__label .variant__label-info span"
    ).text(title);
    if ($(this).find("input").hasClass("disabled")) {
      removeProductFromCartAndSoldOut(prevProdId, actBtn);
      actBtn.find("input[name='id']").val("");
      actBtn.find("input[name='productAmount']").val("");
    } else {
      if (
        actBtn.find("input[name='id']").val() != "" &&
        data.hasOwnProperty(prevProdId)
      ) {
        actBtn.find(".quantity-selector").removeClass("hide");
        actBtn.find(".add-to-cart-btn").addClass("hide");
      }else{
        actBtn.find(".quantity-selector").addClass("hide");
        actBtn.find(".add-to-cart-btn").removeClass("hide");
      }
      actBtn.find("input[name='id']").val(variantId);
      actBtn.find("input[name='productAmount']").val(amount);
      actBtn.find(".sold-out-btn").addClass("hide");
      actBtn.find("#add-to-routine").removeClass("hide");
    }
     var $radio = $(this)
      .closest(".product-bottom-text-last")
      .find("input[data-color-name='" + title + "']");

      $(this).closest(".product-bottom-text-last").find("input[type='radio']").removeClass("checked").prop("checked", false);;
      $radio.each(function () {
        if (!$(this).hasClass("checked")) {
          $(this).addClass("checked");
          $(this).prop("checked", true);
        }
      });
  });

  // Add to cart click handler
  $(document).on("click", ".add-to-cart-btn, #add-to-routine", function (e) {
    var cartItems = localStorage.getItem("cart_items");
    var data = cartItems ? JSON.parse(cartItems) : {};

    var $btn = $(this);
    var $parent = $btn.closest(".atc-btn");
    var productURL = $(this)
      .closest(".modal-product")
      .find(".product-img img")
      .attr("src");
    var productAlt = $(this)
      .closest(".modal-product")
      .find(".product-img img")
      .attr("alt");
    var productID = $parent.find("input[name='id']").val();
    var price = parseFloat($parent.find("input[name='productAmount']").val());
    var qty = parseFloat($parent.find("input[name='quantity']").val());
    var isGift = false;
    var isPreOrder = false;
    
    if($(this).closest(".product-grid").hasClass("gift-product")){
      isGift = true;
    }

    if($(this).closest(".modal-product").find(".product-img .preOrder").length > 0){
      isPreOrder = true;
    }
    
    if($parent.find("input[name='id']").attr("data-prev-id") && data.hasOwnProperty($parent.find("input[name='id']").attr("data-prev-id"))){
      delete data[$parent.find("input[name='id']").attr("data-prev-id")];
      $(
          ".routine-modal-wrapper .lhs-image-wrapper .selected-product-img img[data-id='" +
            $parent.find("input[name='id']").attr("data-prev-id") +
            "']"
        ).remove();
      $parent.find("input[name='id']").attr("data-prev-id",productID);
    }

    if (!data.hasOwnProperty(productID)) {
      qty = 1;
    } else if (data.hasOwnProperty(productID)) {
      qty += 1;
    }

    if (e.target.id == "add-to-routine") {
      $(this).closest(".modal").hide();
    }

    $parent.find("input[name='quantity']").val(qty);

    if (!productID) return;

    if (!data.hasOwnProperty(productID)) {
      $(".routine-modal-wrapper .lhs-image-wrapper .selected-product-img").append(
        '<img src="' +
          productURL +
          '" alt="' +
          productAlt +
          '" data-id="' +
          productID +
          '" />'
      );
    }

    data[productID] = {
      qty: qty,
      price: price,
      image: productURL,
      alt: productAlt,
      isGift: isGift,
      isPreOrder: isPreOrder
    };

    localStorage.setItem("cart_items", JSON.stringify(data));

    toggleQuantityUI();
    updateDiscountProgress();
  });

  // Quantity + button
  $(document).on("click", ".qty-plus", function () {
    var $input = $(this).siblings(".qty-input");
    var newVal = parseInt($input.val()) + 1;
    $input.val(newVal);

    updateLocalStorageQty($input);
  });

  // Quantity - button
  $(document).on("click", ".qty-minus", function () {
    var productID = $(this).closest(".atc-btn").find("input[name='id']").val();
    var $input = $(this).siblings(".qty-input");
    var currentVal = parseInt($input.val());
    if (currentVal > 0) {
      var newVal = currentVal - 1;
      $input.val(newVal);

      if (newVal == 0) {
        $(
          ".routine-modal-wrapper .lhs-image-wrapper .selected-product-img img[data-id='" +
            productID +
            "']"
        ).remove();
      }

      updateLocalStorageQty($input);
    }
  });

  // Quantity input manual change (optional)
  $(document).on("change", ".qty-input", function () {
    updateLocalStorageQty($(this));
  });

  $(document).on("click", "#nextStep", function () {
    var currentStep = $(".discount-step__header.active").data("step");
    var cartItems = localStorage.getItem("cart_items");
    if (currentStep == 1 && !cartItems) {
      return;
    }
    if (currentStep == 1) {
      $(".next-btn #backStep").removeClass("hide");
    }
    if (currentStep == 2) {
      $(".next-btn #nextStep").addClass("hide");
      $(".next-btn #addAll").removeClass("hide");
    }

    $(".discount-step__header").removeClass("active");
    $(".routine-modal-steps .step").removeClass("active");
    if (currentStep < 3) {
      $(
        ".discount-step__header[data-step='" + (currentStep + 1) + "']"
      ).addClass("active");
      $(".routine-modal-steps .step-" + (currentStep + 1)).addClass("active");
    }
  });

  $(document).on("click", "#backStep", function () {
    var currentStep = $(".discount-step__header.active").data("step");
    var cartItems = localStorage.getItem("cart_items");
    if (currentStep == 1) {
      return;
    }
    if (currentStep > 2) {
      $(".next-btn #nextStep").removeClass("hide");
      $(".next-btn #addAll").addClass("hide");
    }

    if (currentStep == 2) {
      $(".next-btn #backStep").addClass("hide");
    }
    $(".discount-step__header").removeClass("active");
    $(".routine-modal-steps .step").removeClass("active");
    if (currentStep > 1) {
      $(
        ".discount-step__header[data-step='" + (currentStep - 1) + "']"
      ).addClass("active");
      $(".routine-modal-steps .step-" + (currentStep - 1)).addClass("active");
    }
  });

  //Open learn more btn
  $(document).on("click", ".open-modal", function () {
    var productID = $(this).closest(".modal-product").data("product-id");
    $("#learn-more-" + productID).show();
  });

  //Close learn more btn
  $(document).on("click", ".modal__close", function () {
    $(this).closest(".modal").hide();
  });

  // swiper slider intilization
  $(".product-gallery-container").each(function (index, element) {
    const $container = $(element);
  
    // Check if it's mobile
    const isMobile = window.innerWidth <= 768;
  
    let thumbSwiper;
  
    // Only init thumbs on desktop
    if (!isMobile) {
      thumbSwiper = new Swiper($container.find(".thumbs-gallery")[0], {
        direction: "vertical",
        slidesPerView: 4,
        spaceBetween: 10,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
      });
    } else {
      // Hide thumbnail container on mobile
      $container.find(".thumbs-gallery").hide();
    }
  
    // Main Swiper
    const mainSwiper = new Swiper($container.find(".main-gallery")[0], {
      spaceBetween: isMobile ? 15 : 10,
      slidesPerView: isMobile ? 1.2 : 1, // show partial slides
      centeredSlides: isMobile ? true : false,
      pagination: {
        el: $container.find(".swiper-pagination")[0],
        clickable: true,
      },
      thumbs: !isMobile
        ? {
            swiper: thumbSwiper,
          }
        : undefined,
    });
  });


  // Tabs using jQuery
  $(document).on("click", ".quick-view-tabs .tab", function () {
    var $tab = $(this);
    var $container = $tab.closest(".quick-view-tabs");

    $container.find(".tab").removeClass("active");
    $container.find(".tab-content").removeClass("active");

    $tab.addClass("active");
    $container.find("#tab-" + $tab.data("tab")).addClass("active");
  });

  $(document).on("click", "#addAll", function () {
    var cartItems = localStorage.getItem("cart_items");
    var data = cartItems ? JSON.parse(cartItems) : {};
    if (Object.keys(data).length > 0) {
      const items = Object.keys(data).map((variantId) => {
        return {
          id: variantId,
          quantity: data[variantId].qty,
        };
      });

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify({
          items: items,
        }),
        success: function (data) {
        },
        error: function (xhr, status, error) {
          console.error("Add to cart failed:", error);
          alert("Failed to add products to cart.");
        },
      });
    }
  });

  // estimate delivery days counter for normal products
  function getDeliveryRange(minDays, maxDays) {
    const today = new Date();
    const options = { month: "long", day: "numeric" };

    const start = new Date(today);
    start.setDate(today.getDate() + minDays);

    const end = new Date(today);
    end.setDate(today.getDate() + maxDays);

    return `Estimated Delivery <span>${start.toLocaleDateString(
      "en-US",
      options
    )}</span> – ${end.toLocaleDateString("en-US", options)}`;
  }

  $(".estimated-delivery").each(function () {
    $(this).html(getDeliveryRange(4, 5));
  });
});
